var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-between",
      staticStyle: { width: "72px" }
    },
    [
      _c(
        "span",
        { staticClass: "en-linea" },
        [
          _c("CampoIndicadorEstadoSii", { attrs: { documento: _vm.documento } })
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "en-linea" },
        [
          _c("CampoIndicadorEstadoComercial", {
            attrs: { documento: _vm.documento }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }